/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var ArticleBlock = (function (_Component) {
	_inherits(ArticleBlock, _Component);

	function ArticleBlock() {
		_classCallCheck(this, ArticleBlock);

		_Component.apply(this, arguments);
	}

	ArticleBlock.prototype.render = function render() {
		var _classNames;

		var styles = require('./ArticleBlock.css');
		var baseClasses = _classnames2['default']((_classNames = {}, _classNames[styles.Base] = true, _classNames[this.props.className] = this.props.className, _classNames[styles['Base--stretched']] = this.props.stretched, _classNames));

		return _react2['default'].createElement(
			'article',
			{ className: baseClasses },
			this.props.imageSrc && _react2['default'].createElement(
				'figure',
				{ className: styles.Figure },
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.FigureLink, to: this.props.uri },
					_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + this.props.imageSrc })
				)
			),
			_react2['default'].createElement(_components.MetaBar, {
				categories: this.props.categories,
				postDate: this.props.postDate,
				specialSeries: this.props.specialSeries
			}),
			_react2['default'].createElement(
				'header',
				{ className: styles.Header },
				_react2['default'].createElement(
					'h1',
					{ className: styles['Title--' + (this.props.stretched ? 'large' : this.props.sansOrSerif)] },
					_react2['default'].createElement(
						_reactRouter.Link,
						{ className: styles.Title, to: this.props.uri },
						this.props.title
					)
				)
			),
			_react2['default'].createElement('div', { className: styles.Content, dangerouslySetInnerHTML: { __html: this.props.content } })
		);
	};

	_createClass(ArticleBlock, null, [{
		key: 'propTypes',
		value: {
			categories: _react.PropTypes.oneOfType([_react2['default'].PropTypes.array, _react2['default'].PropTypes.object]),
			className: _react.PropTypes.string,
			content: _react.PropTypes.string.isRequired,
			imageSrc: _react.PropTypes.string,
			postDate: _react.PropTypes.string.isRequired,
			sansOrSerif: _react.PropTypes.string,
			specialSeries: _react.PropTypes.object,
			stretched: _react.PropTypes.bool,
			title: _react.PropTypes.string.isRequired,
			uri: _react.PropTypes.string.isRequired
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			postDate: 'May 11, 1973',
			title: 'The Title',
			content: '',
			uri: '/',
			sansOrSerif: 'sans',
			stretched: false
		},
		enumerable: true
	}]);

	return ArticleBlock;
})(_react.Component);

exports['default'] = ArticleBlock;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ArticleBlock/ArticleBlock.js
 ** module id = 672
 ** module chunks = 0
 **/